import { useState } from 'react';
import WebhookEndpointsTable from './components/WebhookEndpointsTable';
import WebhookMessagesList from './components/WebhookMessagesList';

function App() {
  const [activeTab, setActiveTab] = useState('endpoints');
  
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-gray-800 shadow-md">
        <div className="container mx-auto px-4 py-6">
          <h1 className="text-3xl font-bold">Webhook Management</h1>
          <p className="mt-2 text-gray-400">Powered by F22</p>
        </div>
      </header>
      
      <nav className="bg-gray-800 border-b border-gray-700">
        <div className="container mx-auto px-4">
          <div className="flex space-x-4">
            <button
              className={`px-3 py-4 text-sm font-medium ${
                activeTab === 'endpoints' 
                  ? 'text-white border-b-2 border-blue-500' 
                  : 'text-gray-300 hover:text-white'
              }`}
              onClick={() => setActiveTab('endpoints')}
            >
              Endpoints
            </button>
            <button
              className={`px-3 py-4 text-sm font-medium ${
                activeTab === 'messages' 
                  ? 'text-white border-b-2 border-blue-500' 
                  : 'text-gray-300 hover:text-white'
              }`}
              onClick={() => setActiveTab('messages')}
            >
              Messages
            </button>
          </div>
        </div>
      </nav>
      
      <main className="container mx-auto px-4 py-6">
        {activeTab === 'endpoints' && <WebhookEndpointsTable />}
        {activeTab === 'messages' && <WebhookMessagesList />}
      </main>
    </div>
  );
}

export default App;